import { Classroom } from '@/api/classroom'

const state = () => ({
    categories: [],
    categoryPagination: 0,
    category: null,
    LoadingCategory: false,
    isSuccessCategory: true,
    messageCategory: '',
})

const getters = {
    categoryList: state => state.categories,
    categoryPagination: state => state.categoryPagination,
    category: state => state.category,
    isLoadingCategory: state => state.isLoadingCategory,
    isSuccessCategory: state => state.isSuccessCategory,
    messageCategory: state => state.messageCategory,

}

const actions = {
    async fetchAllCategories({ commit }) {

        commit('setCategoryIsLoading', true)
        commit('setCategoryPagination', 0)
        await Classroom.categoryListSimple()
            .then(response => {
                commit('setCategories', response.data.data)
                commit('setCategoryIsLoading', false)
            })
            .catch(error => {
                console.log(error)
                commit('setCategoryIsLoading', false)
            })
    },
    updateFrom({ commit }, from) {
        commit('setCategoryPagination', from)
    },
    async fetchDetailCategory({ commit }, id) {
        commit('setCategoryIsLoading', true)
        await Classroom.categoryDetail(id)
            .then(response => {
                // console.log(response)
                commit('setCategoryDetail', response.data.data)
                commit('setCategoryIsLoading', false)
            })
            .catch(error => {
                console.log(error)
                commit('setCategoryIsLoading', false)
            })
    },
    async updateCategory({ commit }, category) {
        const id = category.id
        const payload = category.payload

        await Classroom.categoryEdit(id, payload)
            .then(response => {
                if (response.data.success) {
                    commit('setSuccessCategory', true)
                    commit('setMessageCategory', 'Berhasil Menambahkan Kategori')
                } else {
                    commit('setSuccessCategory', false)
                    commit('setMessageCategory', 'Terjadi Kesalahan')
                }
            })
            .catch(error => {
                commit('setSuccessCategory', false)
                commit('setMessageCategory', error.errors[0].message)
            })
    },
    async addCategory({ commit }, payload) {
        await Classroom.categoryAdd(payload)
            .then(res => {
                if (res.data.success) {
                    commit('setSuccessCategory', true)
                    commit('setMessageCategory', 'Berhasil Menambahkan Kategori')
                } else {
                    commit('setSuccessCategory', false)
                    commit('setMessageCategory', 'Terjadi Kesalahan')
                }
            })
            .catch(error => {
                commit('setSuccessCategory', false)
                commit('setMessageCategory', error.errors[0].message)
            })
    },
    async deleteCategory({ commit }, id) {
        await Classroom.categoryDelete(id)
            .then(res => {
                if (res.data.success) {
                    commit('setSuccessCategory', true)
                    commit('setMessageCategory', 'Berhasil Menghapus Generate Voucher')
                } else {
                    commit('setSuccessCategory', false)
                    commit('setMessageCategory', 'Terjadi Kesalahan')
                }
            })
            .catch(error => {
                commit('setSuccessCategory', true)
                commit('setMessageCategory', error.errors[0].message)
            })
    }
}

const mutations = {
    setCategories: (state, categories) => {
        state.categories = categories
    },
    setCategoryPagination: (state, categoryPagination) => {
        state.categoryPagination = categoryPagination
    },
    setCategoryDetail: (state, category) => {
        state.category = category
    },

    setCategoryIsLoading: (state, isLoadingCategory) => {
        state.isLoadingCategory = isLoadingCategory
    },

    setSuccessCategory: (state, isSuccessCategory) => {
        state.isSuccessCategory = isSuccessCategory
    },

    setMessageCategory: (state, messageCategory) => {
        state.messageCategory = messageCategory
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}